// extracted by mini-css-extract-plugin
export default {"fullWidth":"zn-z","image":"An-z","lazyLoadPicture":"Bn-z","lazyLoadSpinner":"Cn-z","lazyLoadSpin":"Dn-z","lazyLoadImage":"En-z","hasStyledAspectRatio":"Fn-z"};